/** Supprime les balises HTML et trim */
export const sanitize = (str) =>
  typeof str === 'string' ? str.replace(/<[^>]*>/g, '').trim() : '';

/** Valide un email */
export const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

/** Valide un numéro de téléphone (Sénégal : 9 chiffres commençant par 7) */
export const isValidPhone = (phone) =>
  /^[0-9]{9,15}$/.test(phone.replace(/\s+/g, ''));

/** Retourne un objet d'erreurs pour un formulaire.
 *  rules : { fieldName: { required?, minLength?, maxLength?, email?, phone? } }
 *  values : { fieldName: value }
 */
export const validateForm = (values, rules) => {
  const errors = {};
  for (const [field, rule] of Object.entries(rules)) {
    const val = sanitize(String(values[field] ?? ''));
    if (rule.required && !val) {
      errors[field] = 'Ce champ est obligatoire';
    } else if (val && rule.minLength && val.length < rule.minLength) {
      errors[field] = `Minimum ${rule.minLength} caractères`;
    } else if (val && rule.maxLength && val.length > rule.maxLength) {
      errors[field] = `Maximum ${rule.maxLength} caractères`;
    } else if (val && rule.email && !isValidEmail(val)) {
      errors[field] = 'Email invalide';
    } else if (val && rule.phone && !isValidPhone(val)) {
      errors[field] = 'Numéro invalide';
    }
  }
  return errors;
};
